export default {
  noMattersInProfile: 'This {profile} has no {matters}.',
}
